var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91 9.357H2.447A1.446 1.446 0 0 1 1 7.911V2.446A1.446 1.446 0 0 1 2.446 1h5.465a1.446 1.446 0 0 1 1.446 1.446v5.465a1.446 1.446 0 0 1-1.446 1.446Zm9.643 0H12.09a1.447 1.447 0 0 1-1.446-1.446V2.446A1.446 1.446 0 0 1 12.089 1h5.464A1.447 1.447 0 0 1 19 2.446v5.465a1.447 1.447 0 0 1-1.447 1.446ZM7.912 19H2.446A1.447 1.447 0 0 1 1 17.553V12.09a1.447 1.447 0 0 1 1.446-1.446h5.465a1.446 1.446 0 0 1 1.446 1.446v5.464A1.446 1.446 0 0 1 7.911 19Zm9.643 0H12.09a1.447 1.447 0 0 1-1.446-1.447V12.09a1.446 1.446 0 0 1 1.446-1.446h5.464A1.447 1.447 0 0 1 19 12.089v5.464A1.447 1.447 0 0 1 17.553 19Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grid.7364ed8e7750f3242a5f314a423051e1.svg";